import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";
import toast from "react-hot-toast";

import { requestUpdateFeedInsertsSettings } from "./updateFeedInsertsSettings.request";

const useUpdateFeedInsertsSettings = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  const refetchSettings = useRefetchQuery(["feed-inserts-settings"]);

  return useMutation({
    mutationFn: requestUpdateFeedInsertsSettings,
    ...options,
    onSuccess: (...args) => {
      options?.onSuccess?.(...args);
      toast.success("Feed inserts settings updated successfully");
      refetchSettings();
    }
  });
};

export default useUpdateFeedInsertsSettings;
